import ImportEventDataModal from './ImportEventDataModal';

export default ImportEventDataModal;
